<doc>
  @desc:   布局 - 我的赛事组件
  @author:  
</doc>
<template>
  <div class="league-pop-wrapper flex flex-v">
    <h3 class="league-title">{{ langConfig.txtLang[langConfig.curLang]['MY_LEAGUES'] }}</h3>
    <div class="my-league-box">
      <DefaultPic
      :image="require(`@/assets/images/myLeague-no.svg`)"
      :text="'You haven\'t follow any league yet'"
      v-if="myLeagues.length == 0"
       />
      <ul class="league-list" v-if="myLeagues.length > 0">
        <li :class="[{bg: (index + 1) % 2 != 0}]" v-for="(item, index) in myLeagues" :key="index">
          <span class="logo"><img :src="common.leagueImgGet(item['id'], 20)" @error="common.imgError($event, 'team')" /></span>
          <span class="name">{{ item['fullName'] }}</span>
          <span class="btn">
            <i class="fav fav-on" @click.stop="followLeague($event, {id: item['id']})"></i>
          </span>
        </li>
        <!-- <li class="bg">
          <span class="logo"></span>
          <span class="name">联赛全称联赛全称联赛全称联赛全称联赛全称联赛全称联赛全称联赛全称</span>
          <span class="btn">
            <i class="fav fav-on"></i>
          </span>
        </li>
        <li>
          <span class="logo"></span>
          <span class="name">联赛全称联赛全称联赛全称联赛全称联赛全称联赛全称联赛全称联赛全称</span>
          <span class="btn">
            <i class="fav"></i>
          </span>
        </li>
        <li class="bg">
          <span class="logo"></span>
          <span class="name">联赛全称联赛全称联赛全称联赛全称联赛全称联赛全称联赛全称联赛全称</span>
          <span class="btn">
            <i class="fav fav-on"></i>
          </span>
        </li>
        <li>
          <span class="logo"></span>
          <span class="name">联赛全称联赛全称联赛全称联赛全称联赛全称联赛全称联赛全称联赛全称</span>
          <span class="btn">
            <i class="fav"></i>
          </span>
        </li>
        <li class="bg">
          <span class="logo"></span>
          <span class="name">联赛全称联赛全称联赛全称联赛全称联赛全称联赛全称联赛全称联赛全称</span>
          <span class="btn">
            <i class="fav fav-on"></i>
          </span>
        </li>
        <li>
          <span class="logo"></span>
          <span class="name">联赛全称联赛全称联赛全称联赛全称联赛全称联赛全称联赛全称联赛全称</span>
          <span class="btn">
            <i class="fav"></i>
          </span>
        </li>
        <li class="bg">
          <span class="logo"></span>
          <span class="name">联赛全称联赛全称联赛全称联赛全称联赛全称联赛全称联赛全称联赛全称</span>
          <span class="btn">
            <i class="fav fav-on"></i>
          </span>
        </li>
        <li>
          <span class="logo"></span>
          <span class="name">联赛全称联赛全称联赛全称联赛全称联赛全称联赛全称联赛全称联赛全称</span>
          <span class="btn">
            <i class="fav"></i>
          </span>
        </li>
        <li class="bg">
          <span class="logo"></span>
          <span class="name">联赛全称联赛全称联赛全称联赛全称联赛全称联赛全称联赛全称联赛全称</span>
          <span class="btn">
            <i class="fav fav-on"></i>
          </span>
        </li>
        <li>
          <span class="logo"></span>
          <span class="name">联赛全称联赛全称联赛全称联赛全称联赛全称联赛全称联赛全称联赛全称</span>
          <span class="btn">
            <i class="fav"></i>
          </span>
        </li>
        <li class="bg">
          <span class="logo"></span>
          <span class="name">联赛全称联赛全称联赛全称联赛全称联赛全称联赛全称联赛全称联赛全称</span>
          <span class="btn">
            <i class="fav fav-on"></i>
          </span>
        </li> -->
      </ul>
    </div>
  </div>
  <!-- <div class="my-league-wrapper" v-if="myLeagues.length > 0">
    <div class="league-title flex flex-align-center">
      <i class="league-title-icon icon-font icon-collectStar"></i>
      <h3 class="league-title-text">{{ langConfig.txtLang[langConfig.curLang]['MY_LEAGUES'] }}</h3>
    </div>
    <div class="league-item">
      <ul class="league-list">
        <li class="flex flex-align-center" v-for="(item, key) in myLeagues" :key="key">
          <img class="country-flag" :src="common.noCountryBack(item, 'img')" @error="common.imgError($event, 'country')" />
          <span><router-link :to="toLeague(item)" :class="toCss(item)">{{ item['fullName'] }}</router-link></span>
        </li>
      </ul>
    </div>
  </div> -->
</template>

<script>
  //import { mapState, mapMutations, mapActions } from 'vuex';
  import DefaultPic from "@/components/defaultPic.vue";
  export default {
    name: "myLeague",
    components: {
      DefaultPic,
    },
    props: {
      myLeague: {
        type: Object,
        default: () => {},
      }
    },
    data(){
      return{
        myLeagues: [],
      }
    },
    computed: {
    },
    mounted(){
      // this.$watch('leagueData', (val) => {
      //   console.log(val); 
      //   this.myLeague = val;
      // });
    },
    methods: {
      getMyLeagueData(data){
        let _data = this.common.jsonParse(data), _myLeague = [];
        // if(Object.keys(_data).length == 0){
        //   return;
        // }

        for(let key in _data){
          _myLeague.push(_data[key]);
        }

        if(_myLeague.length > 0){
          // a~z 排序
          _myLeague.sort((a, b) => a['fullName'] > b['fullName'] ? 1 : -1);

          this.myLeagues = _myLeague;
        }else{
          this.myLeagues = [];
        }
      },

      // 联赛关注
			followLeague(event, obj){
        event.preventDefault();

        let that = this;

        let _obj = obj;
        this.common.followLeague(_obj, function(val){
          let _myLeague = {};
          _myLeague = val;
          //that.myLeagues = _myLeague;
          if(that.$listeners.onLeagueFollowChange){
            that.$emit('onLeagueFollowChange', _myLeague);
          }else{
          }
        });
      },

      // 跳转联赛
      toLeague(val){
        let _leagueId = val.id, _hasDt = val['hasDt'];
        
        if(typeof(_hasDt) != 'undefined' && _hasDt){
          return '/leagues/' + _leagueId + '/0';
          //this.$router.push('/leagues/' + _leagueId + '/0');
        }else{
          return ''
        }
      },

      //样式
      toCss(val){
        let _leagueId = val.id, _hasDt = val['hasDt'];

        if(typeof(_leagueId) != 'undefined' && _hasDt){
          return '';
        }

        return 'league-title-hover';
      }
    },

    watch: {
      myLeague: {
        immediate: true,
        handler(val) {
          this.getMyLeagueData(val);
        }
      }
    }
  }
</script>

<style lang="less">
.league-pop-wrapper{
    width:498px;
    border-radius: 10px;
    font-family: @font_family_PublicSans_Regular;
    background-color: @color_F5F5F5;
    .league-title{
        flex: none;
        height: 40px;
        font-size:14px;
        font-family: @font_family_PublicSans_Bold;
        color:@color_FFF;
        padding:12px 0 0 25px;
        border-radius: 8px 8px 0 0;
        background-color: @color_262626;
    }
    .my-league-box{
        height: 400px;
        overflow-y: auto;
        border-radius: 0 0 10px 10px;
        margin-bottom: 10px;
        // /* 隐藏默认滚动条 */
        &::-webkit-scrollbar {
            width: 5px; /* 设置滚动条宽度为0.5em */
        }
        /* 修改滚动条的外观 */
        &::-webkit-scrollbar-track {
            background-color: transparent; /* 设置滚动条背景色 */
        }
        &::-webkit-scrollbar-thumb {
            -webkit-border-radius: 3px;
            -moz-border-radius:3px;
            border-radius:3px;
            background-color:@color_8C8C8C; /* 设置滚动条拖动按钮的背景色 */
        }
    }
    .league-list{
        li{
            display: flex;
            align-items: center;
            height: 50px;
            padding:0 25px;
            &.bg{
                background-color: @color_FFF;
            }
            .logo{
                flex: none;
                width: 30px;
                height: 30px;
                margin-right: 10px;
                border-radius: 50%;
                background-color: @color_FFF;
                overflow: hidden;
                display: flex;
                align-items: center;
                justify-content: center;
                img{
                    max-width: 80%;
                    height: auto;
                }
            }
            .name{
                flex: 1;
                margin-right: 10px;
                color: @color_000;
                font-size: 12px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
            .btn{
                display: flex;
                align-items: center;
                justify-content: center;
                width: 22px;
                height: 100%;
                .fav{
                    display: block;
                    width: 18px;
                    height: 18px;
                    background-image: @favIcon;
                    background-repeat: no-repeat;
                    cursor: pointer;
                    background-size: 100% auto;
                }
                .fav-on{
                    background-image: @favSelIcon;
                }
            }
        }
    }    
}
/* phone */
@media screen and (max-width: 767px) {
  .league-pop-wrapper{
    width: 100%;
    height: 90vh;
    padding:.2rem 0;
    margin:0;
    border-bottom-width:.01rem;
    background-color: transparent;
    .league-title-icon{
      font-size:.22rem;
      margin-right:.06rem;
    }
    .league-title{
      display: none;
      font-size:.16rem;
    }
    .my-league-box{
        height: 100%;
        border-radius: 0;
        // /* 隐藏默认滚动条 */
        &::-webkit-scrollbar {
            width: 5px; /* 设置滚动条宽度为0.5em */
        }
        /* 修改滚动条的外观 */
        &::-webkit-scrollbar-track {
            background-color: transparent; /* 设置滚动条背景色 */
        }
        &::-webkit-scrollbar-thumb {
            -webkit-border-radius: 3px;
            -moz-border-radius:3px;
            border-radius:3px;
            background-color:@color_8C8C8C; /* 设置滚动条拖动按钮的背景色 */
        }
    }
    .league-list{
      li{
        height: .26rem;
        padding: 0 .08rem;
        margin-bottom:.08rem;
        &.bg{
          border-radius: .04rem;
          background-color: @color_F5F5F5;
        }
        .logo{
          width: .18rem;
          height: .18rem;
          margin-right: .08rem;
        }
        .name{
          margin-right: .1rem;
          color: @color_8C8C8C;
          font-size: .12rem;
        }
        .btn{
          width: .22rem;
          height: 100%;
          .fav{
              display: block;
              width: .14rem;
              height: .14rem;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// ./src/components/myLeague.vue